import React from 'react'
import styled from 'styled-components'

import { Button } from '../../styles/Buttons'
import { Heading2, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Wrapper = styled.div`
  margin-bottom: 48px;
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    display: flex;
    justify-content: space-between;
  }
`

const ConfirmationSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #f0f1f6;
  padding: 16px;
`

const ConfirmationHeading = styled(Heading2)``

const ConfirmationText = styled.div`
  margin-top: 24px;
`

const ConfirmationButtonWrapper = styled.div`
  margin-top: 40px;
`

const Confirmation = () => {
  return (
    <>
      <Heading>Confirmation</Heading>
      <ConfirmationSection>
        <ConfirmationHeading>Thank you</ConfirmationHeading>
        <ConfirmationText>
          <Paragraph>Thanks for getting in touch, we will get back to you as soon as possible</Paragraph>
        </ConfirmationText>
        <ConfirmationButtonWrapper>
          <Button dark>Find your library</Button>
        </ConfirmationButtonWrapper>
      </ConfirmationSection>
      <Wrapper></Wrapper>
    </>
  )
}

export default Confirmation
